import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { getBaseURL } from 'src/common/helpers/UrlNormalizingHelper';
import { SessionViews } from 'src/common/types/WfaSessionViews';

export const getCurrentWFAFullUrl = (sessionId: string): string =>
	`${getBaseURL()}${RoutesHelper.getWfaSessionPath(sessionId, SessionViews.OVERVIEW)}`;
